export const EMAIL_REGEX =
  /^(?![.!#$%&'*+/=?^_`{|}~-])(?:[a-zA-Z0-9]|(?:(?:([.])(?!\1)|[!#$%&'*+/=?^_`{|}~-]))(?!@)){1,64}@(?=.{1,84}$)(?!\d+$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,64}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,24}[a-zA-Z0-9])?)*$/;
export const COUPON_BODY_REGEX = /^[a-zA-Z0-9]+$/i;
export const USERNAME_REGEX = /^\w+$/;
export const USERNAME_FALSE_UNDERSCORE = /^(?!.*__.*)[a-zA-Z0-9_-]+$/;
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[0-9]).{8,}$/;
